import { render, staticRenderFns } from "./IdeaHomeCards.vue?vue&type=template&id=0436b094&scoped=true"
import script from "./IdeaHomeCards.vue?vue&type=script&lang=js"
export * from "./IdeaHomeCards.vue?vue&type=script&lang=js"
import style0 from "./IdeaHomeCards.vue?vue&type=style&index=0&id=0436b094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0436b094",
  null
  
)

export default component.exports